export default "__VITE_ASSET__DY5hIzvC__"